import 'vuetify/styles'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { aliases, md } from 'vuetify/iconsets/md'
import { createVuetify } from 'vuetify'
import { en, ru } from "vuetify/locale"
import custom_dock from "@/assets/custom_icons/custom_dock.vue"
import custom_search from "@/assets/custom_icons/custom_search.vue"
import custom_filter from "@/assets/custom_icons/custom_filter.vue"
import custom_photo from "@/assets/custom_icons/custom_photo.vue"
import custom_arrow from "@/assets/custom_icons/custom_arrow.vue"
import custom_arrow_sm from "@/assets/custom_icons/custom_arrow_sm.vue"
import custom_arrow_sm_down from "@/assets/custom_icons/custom_arrow_sm_down.vue"
import custom_clip from "@/assets/custom_icons/custom_clip.vue"
import custom_checkbox from "@/assets/custom_icons/custom_checkbox.vue"
import custom_telegram from "@/assets/custom_icons/custom_telegram.vue"
import custom_vkontakte from "@/assets/custom_icons/custom_vkontakte.vue"

const aliasesCustom = {
  ...aliases,
  custom_dock,
  custom_search,
  custom_filter,
  custom_photo,
  custom_arrow,
  custom_arrow_sm,
  custom_arrow_sm_down,
  custom_clip,
  custom_checkbox,
  custom_telegram,
  custom_vkontakte,
}

export default createVuetify({
  icons: {
    defaultSet: 'md',
    aliases: {
      ...aliasesCustom
    },
    sets: {
      md
    }
  },
  locale: {
    locale: 'ru',
    fallback: 'ru',
    messages: { ru, en }
  },
  theme: {
    themes: {
      light: {
        // dark: false,
        // fontFamily: 'Montserrat',
        colors: {
          // primary: '#1976D2'
        }
      }
    }
  }
}
)
